module.exports = __webpack_public_path__ + "static/media/ic_instagram.1bbfe50d.svg";